// M015 accordion
function initAccordions() {

    if ($(".accordion").length > 0) {
        // Guard: jQuery UI accordion may be conditionally loaded.
        if (!$.fn || typeof $.fn.accordion !== "function") {
            return;
        }

        $(".accordion").accordion({
            heightStyle: "content",
            collapsible: true,
            active: false,
        });
    }
}
